import React from 'react'
import { useTranslation } from 'react-i18next';


export default function QuestionScreen1({ changeScreen }) {
    const { t, i18n } = useTranslation();
    return (
        <div className="new-survery-screen text-center">
            <a className="cancel-btn" data-bs-toggle="modal" data-bs-target="#cancelSurvey">
                <svg width={19} height={18} viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L17 17" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" />
                    <path d="M17 1L1 17" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
            </a>
            <div className="surv-question-wrap">
                <div className="icon-wrap">
                    <svg width={99} height={96} viewBox="0 0 99 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M23.0043 3H2.27747V23.7692H23.0043V3Z" stroke="#0F2744" strokeWidth="4.5" strokeMiterlimit={10} strokeLinejoin="round" />
                        <path d="M36.3389 13.3847H77.8616" stroke="#0F2744" strokeWidth="4.5" strokeMiterlimit={10} strokeLinejoin="round" />
                        <path d="M23.0043 37.6154H2.27747V58.3846H23.0043V37.6154Z" stroke="#0F2744" strokeWidth="4.5" strokeMiterlimit={10} strokeLinejoin="round" />
                        <path d="M36.3389 48H98.5884" stroke="#0F2744" strokeWidth="4.5" strokeMiterlimit={10} strokeLinejoin="round" />
                        <path d="M23.0043 72.2308H2.27747V93H23.0043V72.2308Z" stroke="#0F2744" strokeWidth="4.5" strokeMiterlimit={10} strokeLinejoin="round" />
                        <path d="M36.3389 82.6155H77.8616" stroke="#0F2744" strokeWidth="4.5" strokeMiterlimit={10} strokeLinejoin="round" />
                    </svg>
                </div>
                <div className="text-wrapper">
                    <h1 className="question">{t('survey.create1')}</h1>
                    <button className='btn btn-primary ready-btn' onClick={() => { changeScreen('INCREMENT') }}>{t('survey.create2')}</button>
                    <div className="time">
                        <svg width={18} height={18} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx={9} cy={9} r={9} fill="#e60000" /> <path d="M9 4V10.2069H12.4138" stroke="white" strokeWidth="1.5" /> </svg> {t('survey.create3')}
                    </div>
                </div>
            </div>
        </div>
    )
}
